import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SunsetAPIContext } from '../../Networking/ApiProvider';
import { DonatorPackage } from './Donations';
import styles from './PackageView.module.css';
import { Modal } from '../../Components/Modal';


export const PackageView = () => {
  const [donorPackages, setDonorPackages] = useState<DonatorPackage[]>([]);
  const [selectedPackage, setSelectedPackage] = useState<DonatorPackage | null>(null);
  const api = useContext(SunsetAPIContext);

  useEffect(() => {
    fetch(`./samp/donoPackages.json`)
      .then(response => response.json())
      .then(data => setDonorPackages(data))
      .catch(error => console.error("Error fetching donor packages:", error));
  }, [api]);

  const handleCardClick = (donorPackage: DonatorPackage) => {
    setSelectedPackage(donorPackage);

  };

  const handleCloseModal = () => {
    setSelectedPackage(null);
  };

  return (
    <div className={styles.container}>
      <p className={styles.description}>To purchase packages, head in-game and type <strong>/donor</strong>. Rewards and crates are granted automatically.</p>
      {donorPackages.map(donorPackage => (
        <div
          className={`${styles.donorCard} ${styles[donorPackage.apperance]}`}
          key={donorPackage.id}
          onClick={() => handleCardClick(donorPackage)}
        >
          <img className={styles.packageImage} src={`${donorPackage.apperance}.png`} alt={donorPackage.title} />
          <div className="card">
            <h2>{donorPackage.title}</h2>
            {donorPackage.costAfterDiscount ? (
              <div className={styles.priceContainer}>
                <p>Cost: </p>
                <s className={styles.strikethroughPrice}>{donorPackage.cost}</s>
                <strong>{donorPackage.costAfterDiscount}</strong>
                <img src={`${process.env.PUBLIC_URL}/credit.png`} alt="Credits" className={styles.creditImage} />
              </div>
            ) : (
              <div className={styles.priceContainer}>
                <p>Cost: {donorPackage.cost}</p>
                <img src={`${process.env.PUBLIC_URL}/credit.png`} alt="Credits" className={styles.creditImage} />
              </div>
            )}
          </div>
        </div>
      ))}
      {selectedPackage && (
        <Modal key="donorPackageModal" onClose={handleCloseModal}>
          <div className={styles.modalInner}>
            <div className={`${styles.modalHeader} ${styles[selectedPackage.apperance]}`}>
              <h2 className={styles.modalTitle}>{selectedPackage.title}</h2>
            </div>

            <div className={styles.modalMeta}>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Cost</span>
                <span className={styles.metaValue}>
                  {selectedPackage.costAfterDiscount ? (
                    <><s className={styles.oldPrice}>{selectedPackage.cost}</s> {selectedPackage.costAfterDiscount}</>
                  ) : (
                    selectedPackage.cost
                  )}
                  <img src={`${process.env.PUBLIC_URL}/credit.png`} alt="Credits" className={styles.metaCreditImg} />
                </span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Duration</span>
                <span className={styles.metaValue}>{selectedPackage.duration}</span>
              </div>
            </div>

            {Object.keys(selectedPackage.crates).length > 0 && (
              <div className={styles.modalSection}>
                <h3 className={styles.sectionTitle}>Crates</h3>
                <div className={styles.cratesGrid}>
                  {Object.entries(selectedPackage.crates).map(([crateId, quantity]) => (
                    <Link to={`/crates/${crateId}`} className={styles.crateCard} key={crateId}>
                      <img src={`./gamba/${crateId}.png`} alt={`Crate ${crateId}`} />
                      <span className={styles.crateQty}>x{String(quantity)}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )}

            <div className={styles.modalSection}>
              <h3 className={styles.sectionTitle}>Benefits</h3>
              <ul className={styles.benefitsList}>
                {selectedPackage.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
